import React from 'react';

/**
 * The chatbox's focus edge. Place as the first child of a `relative group`
 * composer with `rounded-3xl`. While the composer has focus, a crisp 1.5px
 * indigo→purple line (drifting slowly, like the header controls) draws its
 * outline — no blurred halo. The white layer inside keeps the line to the
 * very edge; the composer's own content sits above it.
 */
export function ComposerRing() {
  return <span aria-hidden className="pointer-events-none absolute -inset-px rounded-[25px] p-[1.5px] opacity-0 group-focus-within:opacity-100 transition-opacity duration-300 ease-out" data-id="element-1994" data-mp="1dh0t7cymxluj">
      <span className="ask-ai-drift absolute inset-0 rounded-[25px] bg-gradient-to-r from-primary-indigo/70 via-ai-purple/80 to-primary-indigo/70 bg-[length:300%_100%]" data-id="element-1995" data-mp="14gb22mkbkjn5" />
      <span className="relative block w-full h-full rounded-[23.5px] bg-white" data-id="element-1996" data-mp="3p7bjwx6n995w" />
    </span>;
}